import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TeacherLeaveForm from "@/components/common/teacher_leave/TeacherLeaveForm.vue";
import Select2Multiple from "v-select2-multiple-component";
import Loading from "vue-loading-overlay";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import ValidationService from '@/services/ValidationService';

export default {
  name: "leaveEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
    TeacherLeaveForm,
  },
  mixins: [ValidationService],

  data() {
    return {
      leaveData: {},
      submitted: false,
      disabled: false,
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      teacherArr: [],
      images: [],
      existingImages: [],
      formValidations: null,
      leaveTypeOptions: [],
      tbdId: null,
    };
  },

  methods: {
    setValidations(validations) {
      this.formValidations = validations;
    },

    getDetail() {
      axios.get(`${this.leaveApiBase}/detail/${this.$route.params.id}`)
        .then(res => {
          this.leaveData = res.data;
          if (!this.leaveData.employee_id && this.leaveData.employee_record_id) {
            this.leaveData.employee_id = this.leaveData.employee_record_id;
          }
          if (this.leaveData.employee_id) this.getLeaveLists();
          if (res.data.leave_images) {
            this.existingImages = res.data.leave_images;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response && error.response.status == 403) {
            this.$router.push({ name: 'teacherLeaveList' });
          }
          this.isLoading = false;
          console.log("Leave Detail API Error", error);
        })
    },

    async getLeaveLists() {
      if (!this.leaveData.employee_id) return;
      const params = { employee_id: this.leaveData.employee_id };
      try {
        const res = await axios.get('leaveType/type-list', {params});
        this.leaveTypeOptions = res.data
          .filter(item => item.type !== 'TBD')
          .map(item => {
            return {
              id: item.id,
              text: item.type
            }
        });
        const tbdOption = res.data.find(item => item.type === 'TBD');
        this.tbdId = tbdOption ? tbdOption.id : null;
      } catch(error) {
        if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
      }
    },

    formatPeriodForRequest(periods) {
      const result = { request_date: {} };
      const groupedByDate = {};

      periods.forEach(p => {
        if (!groupedByDate[p.date]) groupedByDate[p.date] = [];
        groupedByDate[p.date].push(p);
      });

      Object.entries(groupedByDate).forEach(([date, datePeriods]) => {
        const groupedByShift = {};

        datePeriods.forEach(p => {
          const shiftKey = `shift${p.shift}`;
          if (!groupedByShift[shiftKey]) {
            groupedByShift[shiftKey] = [{ 
              from_time: p.from, 
              to_time: p.to 
            }];
          } else {
            let currentRange = groupedByShift[shiftKey][0];
            if (p.from < currentRange.from_time) {
              currentRange.from_time = p.from;
            }
            if (p.to > currentRange.to_time) {
              currentRange.to_time = p.to;
            }
          }
        });
        result.request_date[date] = groupedByShift;
      });
      return result;
    },

    handlePeriodOptions(periodOptions) {
      this.periodOptions = periodOptions;
    },

    update() {
      this.isLoading = true;
      this.submitted = true;
      this.disabled = true;

      this.formValidations.$touch(); 
      if (this.formValidations.$invalid) {
        this.isLoading = false;
        this.disabled = false;
        return;
      }
      this.leaveData.leave_images = this.existingImages;
      this.leaveData.new_images = this.images;
      if (this.leaveData.leave_type_id) {
        this.leaveData.selected_leave_type = this.leaveData.leave_type_id;
      }
      const periodPayload = this.formatPeriodForRequest(this.leaveData.period)
      if (this.leaveData.leave_date && !periodPayload.request_date[this.leaveData.leave_date]) {
        periodPayload.request_date = {
          [this.leaveData.leave_date]: periodPayload.request_date[this.leaveData.leave_date] || {}
        };
      }

      const leaveData = this.leaveData;
      const payload = { ...leaveData, period: periodPayload };
      axios.post(`${this.leaveApiBase}/update/${this.$route.params.id}`, payload)
        .then(res => {
          if(res.data.success == true) {
            this.$notification.success("Leave Form Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "teacherLeaveList"
            });
          }
        })
        .catch(error => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
              return;
            }
            if (error.response.status == 403) {
              this.$notification.error(
                error.response.data?.message || "You are not allowed to edit this leave record.",
                {
                  timer: 3,
                  position: "bottomCenter",
                }
              );
              this.$router.push({ name: "teacherLeaveList" });
            }
            if (error.response.status == 422) {
              this.printValidationError(error.response);
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
        })
    }
  },

  computed: {
    isHrOperator() {
      const role = Number(this.$store.state.user?.role);
      return role === CONFIG.ROLE.ID.HR_OPERATOR || role === CONFIG.ROLE.ID.SUPER_ADMIN;
    },
    leaveApiBase() {
      return this.isHrOperator ? 'hr/employee-leave' : 'employee-leave';
    },
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
  },
};
